<template>
  <div>
    <div class="text-left">
      <h4 class="mb-8 mt-4 text-dark-gray sm:mt-2">
        {{
          firstTime
            ? 'Do you have any of these other certifications?'
            : 'Also, review what was previously self-reported about these other certifications.'
        }}
      </h4>
      <div v-if="firstTime">
        <label class="text-dark-blue">CERTIFICATIONS</label>
        <div class="flex flex-wrap items-start">
          <div
            v-for="certification in certifications"
            :key="certification.id"
            class="w-1/2 p-1 md:w-1/3"
          >
            <radio-button
              :key="certification"
              :item="certification"
              :active="
                data.certifications?.find(
                  (el) =>
                    (el.is_type === 'Tank Endorsed Drivers' &&
                      certification === 'Tanker Endorsed Drivers') ||
                    el.is_type === certification
                )
              "
              name="untracked_certifications"
              :handle-select="handleSelect"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="flex"
      >
        <div
          v-if="data.untracked_certifications?.length"
          class="mr-4"
        >
          <label
            v-if="data.untracked_certifications?.length"
            class="text-dark-gray"
          >
            CERTIFIED
          </label>
          <ul class="flex flex-row flex-wrap gap-3">
            <li
              v-for="certification in data.untracked_certifications"
              :key="certification"
              class="text-sm text-dark-gray"
            >
              <div v-if="certifications.length">
                <div class="flex gap-1">
                  {{ certification }}
                  <img
                    src="@/assets/certified.svg"
                    alt="certified icon"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-if="!firstTime && uncertifiedString"
          class="text-left text-gray-over-dark"
        >
          <label>UNCERTIFIED</label>
          <p>{{ uncertifiedString }}</p>
        </div>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed } from 'vue';
import moment from 'moment';
import RadioButton from '../../../components/RadioButton.vue';
import stepInformation from '@/common/stepInformation';

export default {
  name: 'CertificationsStepTwo',
  components: {
    'radio-button': RadioButton,
    FormNavigationButtons,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup(props, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Certifications-2';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = computed(() => {
      if (firstTime.value) return 'continue-save';
      return 'continue-edit';
    });
    const isButtonDisabled = false;

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToNextStep();
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
    };

    const handleSelect = async (e) => {
      const value =
        e.target.value === 'Tanker Endorsed Drivers'
          ? 'Tank Endorsed Drivers'
          : e.target.value;
      let initialCertifications = [...props.data.certifications];
      initialCertifications = initialCertifications.map((cert) => {
        let modCert = {
          is_type: cert.is_type,
          external_id: cert.external_id,
          file_date: cert.file_date,
          _destroy: 0,
        };
        return modCert;
      });
      let certificationBodyArr =
        store.state.onboardingPacket.onboardingPacketBody.carrier
          ?.certifications_attributes ||
        initialCertifications ||
        [];
      const findExisting = props.data.certifications.find(
        (el) => el.is_type === value
      );
      const existsInPacket = certificationBodyArr.find(
        (el) => el.is_type === value
      );

      if (findExisting) {
        // Remove item if exists
        if (existsInPacket) {
          // remove item from add packet body
          const filteredArr = certificationBodyArr.filter(
            (el) => el.is_type !== value
          );
          certificationBodyArr = filteredArr;
        } else {
          // destroy item
          certificationBodyArr.push({
            id: findExisting.id,
            is_type: value,
            _destroy: 1,
          });
        }

        const updatedArray = props.data.certifications.filter(
          (item) => item.is_type !== value
        );
        props.updateField('certifications', updatedArray);
      } else {
        // Add item
        const date = new Date();
        const currentDate = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');

        if (existsInPacket) {
          // remove item from destory packet body
          const filteredArr = certificationBodyArr.filter(
            (el) => el.is_type !== value
          );
          certificationBodyArr = filteredArr;
        } else {
          certificationBodyArr.push({
            is_type: value,
            external_id: null,
            file_date: currentDate,
            _destroy: 0,
          });
        }

        const updatedArray = [
          ...(props.data.certifications || []),
          { is_type: value },
        ];
        props.updateField('certifications', updatedArray);
      }

      await store.dispatch('onboardingPacket/setOnboardingBody', {
        carrier: {
          certifications_attributes: certificationBodyArr,
        },
      });
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };
    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      handleSelect,
      emitExitModal,
    };
  },
  data() {
    return {
      certifications: [],
    };
  },
  computed: {
    uncertifiedString() {
      let uncertified = this.certifications.filter(
        (el) => !this.data.untracked_certifications.includes(el)
      );
      return uncertified.join(', ');
    },
  },
  watch: {
    stepName: {
      handler: async function (newVal) {
        let self = this;
        if (newVal === 'Certifications-2') {
          await self.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'CertificationsStepTwo #2',
          });
        }
      },
    },
  },
  async mounted() {
    this.certifications =
      stepInformation.certifications.untracked_certifications;
    // await this.$store.dispatch("onboardingPacket/presetExistingCertifications", this.data.certifications);
  },
};
</script>

<style scoped>
label {
  @apply mb-1 font-bold;
  font-size: 9px;
  line-height: 13.5px;
  display: inline-block;
}
</style>
